module.exports = new __parcel__URL__("frame.bbe65a09.svg").toString();